var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeSolidB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 1.53833C5.75559 1.53833 3.95837 2.54458 2.65004 3.74224C1.35004 4.92896 0.480594 6.35083 0.0694824 7.327C-0.0221842 7.54302 -0.0221842 7.78364 0.0694824 7.99966C0.480594 8.97583 1.35004 10.3977 2.65004 11.5844C3.95837 12.7821 5.75559 13.7883 8.00004 13.7883C10.2445 13.7883 12.0417 12.7821 13.35 11.5844C14.65 10.395 15.5195 8.97583 15.9334 7.99966C16.025 7.78364 16.025 7.54302 15.9334 7.327C15.5195 6.35083 14.65 4.92896 13.35 3.74224C12.0417 2.54458 10.2445 1.53833 8.00004 1.53833ZM4.00004 7.66333C4.00004 6.61904 4.42147 5.61752 5.17161 4.8791C5.92176 4.14067 6.93917 3.72583 8.00004 3.72583C9.0609 3.72583 10.0783 4.14067 10.8285 4.8791C11.5786 5.61752 12 6.61904 12 7.66333C12 8.70762 11.5786 9.70914 10.8285 10.4476C10.0783 11.186 9.0609 11.6008 8.00004 11.6008C6.93917 11.6008 5.92176 11.186 5.17161 10.4476C4.42147 9.70914 4.00004 8.70762 4.00004 7.66333ZM8.00004 5.91333C8.00004 6.87856 7.20282 7.66333 6.22226 7.66333C6.02504 7.66333 5.83615 7.63052 5.65837 7.5731C5.50559 7.52388 5.32782 7.61685 5.33337 7.77544C5.3417 7.96411 5.36948 8.15278 5.42226 8.34145C5.80282 9.74146 7.2667 10.5727 8.68893 10.1981C10.1111 9.82349 10.9556 8.38247 10.575 6.98247C10.2667 5.84771 9.24726 5.08481 8.11393 5.03833C7.95282 5.03286 7.85837 5.20513 7.90837 5.35825C7.96671 5.53325 8.00004 5.71919 8.00004 5.91333Z",
    fill: "#B2B2B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "white",
    transform: "translate(0 0.66333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSolidB);
export default __webpack_public_path__ + "static/media/eye-solid-b.b34dc70149c8014bc6abfd12eba52a56.svg";
export { ForwardRef as ReactComponent };